export default __webpack_public_path__ + "static/media/Calendar.b5b24936.svg";